import { createSelector } from "reselect";
const findByType = (notifications, type) => notifications.find((n) => n.type === type);
const findByCategory = (notifications, category) => notifications.filter((n) => n.category === category);
export const getNotifications = (domain) => { var _a; return (_a = domain === null || domain === void 0 ? void 0 : domain.notifications) !== null && _a !== void 0 ? _a : []; };
export const getByCategory = (category) => createSelector([getNotifications], (notifications) => findByCategory(notifications, category));
export const getExtensionNotifications = createSelector([getNotifications], (notifications) => {
    var _a;
    return (_a = notifications.reduce((acc, notification) => {
        var _a;
        if (notification.type !== "notifications-accounts")
            return acc;
        if (((_a = notification.metadata) === null || _a === void 0 ? void 0 : _a.hasPendingExtension) !== "true")
            return acc;
        return [...acc, notification];
    }, [])) !== null && _a !== void 0 ? _a : [];
});
export const getVehicleUnreadMessageCount = createSelector([getNotifications], (notifications) => {
    var _a, _b, _c;
    return (_c = (_b = (_a = findByType(notifications, "AUTO_SECURE_UNREAD_MESSAGE_COUNT")) === null || _a === void 0 ? void 0 : _a.metadata) === null || _b === void 0 ? void 0 : _b.unreadMsgCount) !== null && _c !== void 0 ? _c : 0;
});
export const getBankUnreadMessageCount = createSelector([getNotifications], (notifications) => {
    var _a, _b, _c;
    return (_c = (_b = (_a = findByType(notifications, "BANK_SECURE_UNREAD_MESSAGE_COUNT")) === null || _a === void 0 ? void 0 : _a.metadata) === null || _b === void 0 ? void 0 : _b.unreadMsgCount) !== null && _c !== void 0 ? _c : 0;
});
export const getInvestUnreadMessageCount = createSelector([getNotifications], (notifications) => {
    var _a, _b, _c;
    return (_c = (_b = (_a = findByType(notifications, "INVEST_SECURE_UNREAD_MESSAGE_COUNT")) === null || _a === void 0 ? void 0 : _a.metadata) === null || _b === void 0 ? void 0 : _b.unreadMsgCount) !== null && _c !== void 0 ? _c : 0;
});
//# sourceMappingURL=index.js.map